import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdArrowBack, MdEmail } from 'react-icons/md'; // Material Design email icon
import { MdVisibility } from 'react-icons/md'; // Material Design email icon
import { MdVisibilityOff } from 'react-icons/md'; // Material Design email icon
import { MdLock } from 'react-icons/md'; // Material Design email icon
import { MdEdit, MdFormatQuote, MdMenuBook, MdPerson, MdPersonPinCircle, MdVideoCameraBack } from "react-icons/md";
import { Commet } from 'react-loading-indicators';
import axios from 'axios';
import { web_url } from '../../constant';

const url = "http://localhost:8080/api/";
function ResearcherChangePassword() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const handleAgree = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [userNewPasswordDetails, setUserNewPasswordDetails] = useState(
        {
            password: '',
            confirmPassword: '',
        }
    )

    const [errors, setErrors] = useState(
        {
            noPassword: false,
            passwordsNotMatch: false,
        }
    )

    const handleContinue = () => {

        let newErrors = {};

        newErrors.noPassword = !userNewPasswordDetails.password;

        if (userNewPasswordDetails.password && (userNewPasswordDetails.confirmPassword) !== (userNewPasswordDetails.password)) {
            newErrors.passwordsNotMatch = true;
        } else {
            newErrors.passwordsNotMatch = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }
        handleClickOpen();
    }

    const handleChange = () => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const user = {
            newPassword: userNewPasswordDetails.confirmPassword,
            userRole: "RESEARCHER"
        };

        const apiUrl = `${url}auth/change-password/${logDetails.email}`;
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };


        axios.put(`${web_url}/api/auth/change-password/${logDetails.email}`, user, config)
            .then((response) => {
                console.log("API Response:", response.data);
                setIsLoading(false);
                setOpen(false);
                handleClickOpen2(true);
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } if (err.response.data.token) {
                        handleClickOpenError(err.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })

    }

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisibleText2, setIsVisibleText2] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const handleVisiblityClick2 = () => {
        setIsVisible2(!isVisible2);
        if (!isVisible2 && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText2(true);
        } else if (isVisible2 && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText2(false);
        }
    }

    const [passwordStatus, setPasswordStatus] = useState({
        weak: false,
        medium: false,
        strong: false
    })

    const errorMessages =
        [
            '',
            t('t60'),
            t('t61'),
            t('t62'),
            t('t63'),
            t('t64'),
        ]

    const [errorMessageNumber, setErrorMessageNumber] = useState(0)

    const regexPatterns = [
        /^.{1,7}$/,  // weak password
        /^(?:[a-z]{8,}|[A-Z]{8,}|[0-9]{8,}|[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,})$/,  // medium password
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#*$%^&+=]).{8,}$/,  // strong password
        /(?=.*[A-Z])/,  // contains at least 1 uppercase letter
        /(?=.*[a-z])/,  // contains at least 1 lowercase letter
        /(?=.*[0-9])/,  // contains at least 1 numeric digit
        /(?=.*[!@#*$%^&+=])/,  // contains at least 1 special character
        /^.{8,}$/,  // password length greater than 8 characters
    ];

    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/loginas')
    };

    return (
        <div className="pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
            <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                    navigate('/mobile/researcher/settings')
                }} />
                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                    navigate('/mobile/researcher/settings')
                }} />
                <p className="text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t162')}</p>
            </div>

            <div className='flex flex-col justify-center items-center h-full w-full'>
                <img src="/images/password.svg" className="mt-[20px] h-[80px]" alt='logo' />
                <p className="text-center text-[20px] mt-[10px]">{t('t76')}</p>

                <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdLock size="26px" color="#8189B0" />
                    <input
                        type={isVisibleText ? "text" : "password"}
                        name="password"
                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                        placeholder={t('t17')}
                        value={userNewPasswordDetails.password}
                        onChange={(e) => {

                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                            if (inputValue !== "") {
                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                if (regexPatterns[2].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: true }));

                                } else if (regexPatterns[1].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                } else if (regexPatterns[0].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: true, strong: false }));

                                } else {
                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                }
                            } else {
                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: false }));
                            }

                            if (inputValue !== '') {
                                if (!regexPatterns[3].test(inputValue)) {
                                    setErrorMessageNumber(1)
                                } else if (!regexPatterns[4].test(inputValue)) {
                                    setErrorMessageNumber(2)
                                } else if (!regexPatterns[5].test(inputValue)) {
                                    setErrorMessageNumber(3)
                                } else if (!regexPatterns[6].test(inputValue)) {
                                    setErrorMessageNumber(4)
                                } else if (!regexPatterns[7].test(inputValue)) {
                                    setErrorMessageNumber(5)
                                } else {
                                    setErrorMessageNumber(0)
                                }
                            } else {
                                setErrorMessageNumber(0)
                            }

                            setUserNewPasswordDetails((prevState) => ({
                                ...prevState, password: inputValue
                            }));
                            if (!isVisible && inputValue.length > 0) {
                                setIsVisibleText(false);
                            } else {
                                setIsVisibleText(true);
                            }
                        }}
                    />
                    {
                        isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                    }
                </div>

                {errors.noPassword &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t18')}</p>
                }

                {passwordStatus.weak && <p className='text-black text-[12px] mt-[5px] '>{t('t65')}<span className='text-[#fc0000] font-bold'>{t('t66')}</span></p>
                }
                {passwordStatus.medium && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#fc8600] font-bold'>{t('t67')}</span></p>
                }
                {passwordStatus.strong && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#099509] font-bold'>{t('t68')}</span></p>
                }

                {errorMessageNumber !== 0 && <p className='text-[#ff0000] text-[12px] mt-[5px] '>{errorMessages[errorMessageNumber]}</p>}

                <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdLock size="26px" color="#8189B0" />
                    <input type={isVisibleText2 ? "text" : "password"}
                        name="password_confirm"
                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText2 ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                        placeholder={t('t30')}
                        value={userNewPasswordDetails.confirmPassword}
                        onChange={(e) => {
                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                            setUserNewPasswordDetails((prevState) => ({
                                ...prevState, confirmPassword: inputValue
                            }));
                            if (!isVisible2 && inputValue.length > 0) {
                                setIsVisibleText2(false);
                            } else {
                                setIsVisibleText2(true);
                            }
                        }}
                    />
                    {
                        isVisible2 ? <MdVisibilityOff onClick={handleVisiblityClick2} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick2} size="24px" color="#8189B0" />
                    }
                </div>
                {errors.passwordsNotMatch &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t26')}</p>
                }
                <button onClick={handleContinue} className="text-[18px] mt-[40px] rounded-lg pt-[10px] pb-[10px] w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t52')}</button>
            </div>
            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            {
                                isLoading ?
                                    <div className="items-center justify-center flex">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#F2AC0E] rounded-full animate-spin'></div>
                                    </div>
                                    : <>
                                        <div className='mt-[0px]'>{t('t163')}</div>
                                        <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                            <Button
                                                onClick={handleClose}
                                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                            >
                                                {t('t145')}
                                            </Button>
                                            <Button
                                                onClick={() => { handleChange() }}
                                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                            >
                                                {t('t144')}
                                            </Button>
                                        </div>
                                    </>
                            }
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>


                            <div className='mt-[0px]'>{t('t164')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t7')}
                                </Button>
                            </div>

                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default ResearcherChangePassword;



